(function () {
  var OFFSET = 20;
  var DURATION = 300;

  // Sekcja recenzji jest w DOM dwa razy — wersja desktopowa siedzi w kolumnie
  // zakupowej, mobilna w treści pod nią. Przewijamy do tej faktycznie widocznej.
  function visibleAnchor() {
    var anchors = document.querySelectorAll('.js-reviews-anchor');

    for (var i = 0; i < anchors.length; i++) {
      if (anchors[i].offsetParent !== null) {
        return anchors[i];
      }
    }

    return null;
  }

  // Po przyklejeniu panelu StickySidebar ustawia wrapper na position: fixed,
  // więc getBoundingClientRect() jego potomków opisuje pozycję w oknie, a nie
  // w dokumencie. Pozycję docelową składamy wtedy z miejsca kolumny (ta zostaje
  // w normalnym układzie) i przesunięcia elementu wewnątrz wrappera.
  function documentTop(element) {
    var wrapper = element.closest ? element.closest('.inner-wrapper-sticky') : null;

    if (!wrapper || !wrapper.parentNode) {
      return element.getBoundingClientRect().top + window.pageYOffset;
    }

    var column = wrapper.parentNode;
    var insideWrapper = element.getBoundingClientRect().top - wrapper.getBoundingClientRect().top;

    return column.getBoundingClientRect().top + window.pageYOffset + insideWrapper;
  }

  function scrollTo(top) {
    if (window.jQuery) {
      window.jQuery('html, body').animate({ scrollTop: top }, DURATION);

      return;
    }

    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('.product-stars__count') : null;

    if (!link) {
      return;
    }

    var target = visibleAnchor();

    if (!target) {
      return;
    }

    event.preventDefault();
    scrollTo(Math.max(0, documentTop(target) - OFFSET));
  });
})();
